import { styled } from "styled-components";

import { ErrorIcon } from "common/components/icons";

export const ErrorMessageContainer = styled.div`
  align-items: center;
  background-color: transparent;
  border-radius: 5px;
  border: 2px solid ${({ theme }) => theme.colors.error};
  color: ${({ theme }) => theme.colors.textBright};
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin: 0.75rem 0 1.5rem;
  padding: 0.5rem 1rem;
`;

export const Icon = styled(ErrorIcon)`
  color: ${({ theme }) => theme.colors.textBright};
  flex-shrink: 0;
  height: 20px;
  width: 20px;
`;

export const ErrorMessage = styled.p`
  margin: 0;

  strong {
    cursor: pointer;
  }
`;
